export const tableData = [
  {
    id:'bill',
    firstName:'Bill',
    lastName: 'Sommers',
    age: 30,
    amount: 1245676,
    radioChecked: 'Digital Test'  
  },
  {
    id:'lorry',
    firstName:'Lorry',
    lastName: 'Leon',
    age: 32,
    amount: 1245676,
    radioChecked: 'Digital Test'
  },
  {
    id:'james',
    firstName:'James',
    lastName: 'Fonn',
    age: 36,
    amount: 124,
    radioChecked: 'Digital Test'
  },
  {
    id:'james',
    firstName:'Peters',
    lastName: 'John',
    age: 30,
    amount: 1245676,
    radioChecked: 'Digital Test'    
  },
  {
    id:'jaun',
    firstName:'Jaun',
    lastName: 'Guha',
    age: 30,
    amount: 12456766757,
    radioChecked: 'Digital Test'    
  },
  {
    id:'emma',
    firstName:'Emma',
    lastName: 'Nicholos',
    age: 42,
    amount: 1245676958748,
    radioChecked: 'Digital Test'    
  },
  {
    id:'jamese',
    firstName:'Jamese',
    lastName: 'Watson',
    age: 30,
    amount: 124567,
    radioChecked: 'Digital Test'        
  },
  {
    id:'jhon',
    firstName:'Jhon',
    lastName: 'Sommers',
    age: 30,
    amount: 1245676,
    radioChecked: 'Digital Test'    
  },
  {
    id: 'lorrys',
    firstName:'Lorrys',
    lastName: 'Leon',
    age: 32,
    amount: 1245676,
    radioChecked: 'Digital Test'    
  },
  {
    id:'jame',
    firstName:'Jame',
    lastName: 'Fonn',
    age: 36,
    amount: 124,
    radioChecked: 'Digital Test'    
  },
  {
    id:'peter',
    firstName:'Peter',
    lastName: 'John',
    age: 30,
    amount: 1245676,
    radioChecked: 'Digital Test'    
  },
  {
    id:'jauns',
    firstName:'Jauns',
    lastName: 'Guha',
    age: 30,
    amount: 12456766757,
    radioChecked: 'Digital Test'    
  },
  {
    id:'emmaa',
    firstName:'Emmaa',
    lastName: 'Nicholos',
    age: 42,
    amount: 1245676958748,
    radioChecked: 'Digital Test'    
  },
  {
    id:'wade',
    firstName:'Wade',
    lastName: 'Watson',
    age: 30,
    amount: 124567,
    radioChecked: 'Digital Test'        
  },
  {
    id:'dave',
    firstName:'Dave',
    lastName: 'Sommers',
    age: 30,
    amount: 1245676,
    radioChecked: 'Digital Test'    
  }
]

export const columnMappings = [
  {
    field: 'firstName',
    headerName: 'First Name',
    type : 'text'
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    type : 'text'
  },
  {
    field: 'age',
    headerName: 'Age',
    type : 'number'
  },
  {
    field: 'amount',
    headerName: 'Amount',
    type : 'number',
    // you have to specify inside column header defnition how will be the td element to be rendered
    valueFormatter: (params: any) => {
      return params.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  {
    field: 'digitalTest',
    headerName: 'Digital Test',
    type : 'radio'
  },
  {
    field: 'paperTest',
    headerName: 'Paper Test',
    type : 'radio'
  }
]

export const columnHeader = [
  {
    field: 'firstName',
    headerName: 'First Name',
    type : 'text'
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    type : 'text'
  },
  {
    field: 'digitalTest',
    headerName: 'Digital Test',
    type : 'radio'
  },
  {
    field: 'paperTest',
    headerName: 'Paper Test',
    type : 'radio'
  }
]

export const tableDataWithoutNumbers = [
   {
    id:'noah',
    firstName:'Noah',
    lastName: 'Leon',
    radioChecked: 'Digital Test'
  },
  {
    id:'oliver',
    firstName:'Oliver',
    lastName: 'Fonn',
    radioChecked: 'Digital Test'
  },
  {
    id:'george',
    firstName:'George',
    lastName: 'John',
    radioChecked: 'Digital Test'
    
  }
]

export const textColumnHeaders = [
  {
    field: 'sNo',
    headerName: 'S. No.',
    type : 'number'
  },
  {
    field: 'studentName',
    headerName: 'Student Name',
    type : 'text'
  },
  {
    field: 'userName',
    headerName: 'User Name',
    type : 'text'
  }
]

export const tableDataWithText = [
   {
    sNo:1,
    id:'leon',
    studentName: 'Leon',
    userName: 'Noah'
  },
  {
    sNo:2,
    id:'oliver',
    studentName:'Oliver',
    userName: 'Fonn',
    tooltipMessage: 'Student moved to class B by Marcus Taytum on 27 September 2026. Grades and feedback can no longer be added or edited',
    disabled: true
  },
  {
    sNo:3,
    id:'george',
    studentName:'George',
    userName: 'John'
  }
]

export const newTextColumnHeaders = [
  {
    field: 'studentName',
    leftColumnFixed: false, 
    headerName: 'Student Name',
    type : 'text',
    alignment:'left'
  },
  {
    field: 'totalScore',
    headerName: 'Total Score/90', 
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    icon: 'icon-info-circle',
    type : 'number',
    alignment:'right'
  },
  {
    field: 'activities',
    headerName: 'Activities - Scores achieved for each activity (first attempt)',
    type : 'number',
    alignment:'center',
    icon: 'icon-info-circle',
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    subHeader: [{
      headerName: '1',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '2',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '3',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '4',
      type:'number',
      alignment:'right'
    }
  ],
  
  },
  {
    field: 'feedBack',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  },
  {
    field: 'actions',
    rightColumnFixed: true,
    headerName: 'Actions',
    type : 'dropdown',
    alignment:'center'
  }
]

export const studentData:any = [
  {
    id:1,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Aleksander Jordan',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan',
          link: { label: 'Aleksander Jordan', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj12',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt1',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5(100%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt2',
          link: { label: 'updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '9/10(90%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt3',
          link:{ label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4', 
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45(75%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt4',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View1',
          link: { label: 'View', labelledBy:'studentNamedata_01 View1', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd40',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:2,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Aniela Keneddy',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aniela Keneddy',
          link: { label: 'Aniela Keneddy', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'KeneddyA',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        bandColor: '#E7F3EA',
        values: {
          text: '41(45%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '21/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '8/10 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View2',
          link: { label: 'Give', labelledBy:'studentNamedata_11 View2', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd39',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:3,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Bardara Freeman',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Bardara Freeman',
          link: { label: 'Bardara Freeman', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'magicbardara',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',

    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',  
      items: [{
        type: 'label',
        values: {
          text: '22/30(80%)'
        }
      }]   
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5(100%)'
        }
      }]
     
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state: 'Not Started'
        }
      }]
     
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state: 'Requires grading'
        }
      }]
     
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View3',
          link: { label: 'View', labelledBy:'studentNamedata_21 View3', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd38',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:4,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Brandon Nichols',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Brandon Nichols',
          link: { label: 'Brandon Nichols', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'brandon1000',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',

    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',  
      items: [{
        type: 'label',
        values: {
          text: '23/30 (80%)'
        }
      }]   
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }]
     
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state: 'Not Started'
        }
      }]
     
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state: 'Requires grading'
        }
      }]
     
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View4',
          link: { label: 'View', labelledBy:'studentNamedata_31 View4', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd37',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:5,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Daniel Jackson',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Daniel Jackson',
          link: { label: 'Daniel Jackson', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'danjack',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        bandColor: '#FFF2ED',
        iconList: [{icon:'icon-backpack',
                    iconName:'backpack',
                    tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                  iconName:'platinum Trophy',
                  tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        values: {
          text: '33 (36%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '18/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '5/10 (50%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View5',
          link: { label: 'Give', labelledBy:'studentNamedata_41 View5', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd36',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:6,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Daniel Zeller',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Daniel Zeller',
          link: { label: 'Daniel Zeller', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'daniel_Zeller',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        bandColor: '#ECF1FB',
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                  iconName:'platinum Trophy',
                  tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        values: {
          text: '77 (85%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '23/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '10/10 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View6',
          link: { label: 'Give', labelledBy:'studentNamedata_51 View6', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd35',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:7,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Grace Collins',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Grace Collins',
          link: { label: 'Grace Collins', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'gracecc',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '25 (28%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '17/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '8/10 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View7',
          link: { label: 'View', labelledBy:'studentNamedata_61 View7', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd34',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:8,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Henry Brown',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Henry Brown',
          link: { label: 'Henry Brown', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'henryTheBest',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '43 (47%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '24/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '6/10 (60%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View8',
          link: { label: 'View', labelledBy:'studentNamedata_71 View8', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd33',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:9,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Jhon Carter',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Jhon Carter',
          link: { label: 'Jhon Carter', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'daniel_Zeller',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not started'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View9',
          link: { label: 'View', labelledBy:'studentNamedata_81 View9', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd32',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:10,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Madison McDonalds',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Madison McDonalds',
          link: { label: 'Madison McDonalds', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'MaaAaad',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '45 (50%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '22/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View10',
          link: { label: 'View', labelledBy:'studentNamedata_91 View10', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd31',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:11,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Marcus Kirby',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Marcus Kirby',
          link: { label: 'Marcus Kirby', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'kirby',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '70 (79%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '22/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '4/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View11',
          link: { label: 'View', labelledBy:'studentNamedata_101 View11', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd30',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:12,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Maria Kelly',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Maria Kelly',
          link: { label: 'Maria Kelly', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'maria_k',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '74 (82%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '21/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '3/5(100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View12',
          link: { label: 'Give', labelledBy:'studentNamedata_111 View12', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd29',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:13,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Melinda Patterson',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Melinda Patterson',
          link: { label: 'Melinda Patterson', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'melindap',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '80 (89%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '19/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '2/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'studentNamedata_121 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd28',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:14,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Penelope Davis',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Penelope Davis',
          link: { label: 'Penelope Davis', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'sonny3',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '29 (33%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '21/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '4/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View14',
          link: { label: 'Give', labelledBy:'studentNamedata_131 View14', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd27',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:15,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Peter Adot',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Peter Adot',
          link: { label: 'Peter Adot', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'peteado',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
     }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Requires grading'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Requires grading'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Requires grading'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Requires grading'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View15',
          link: { label: 'Give', labelledBy:'studentNamedata_141 View15', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd26',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:16,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Renata Newman',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Renata Newman',
          link: { label: 'Renata Newman', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'renata_new',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not Started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not Started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not Started'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: ' ',
          state:'Not Started'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View16',
          link: { label: 'View', labelledBy:'studentNamedata_151 View16', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd25',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:17,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Sylvia Zeller',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Sylvia Zeller',
          link: { label: 'Sylvia Zeller', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'Sylvia150',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '79 (85%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '24/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View17',
          link: { label: 'Give', labelledBy:'studentNamedata_161 View17', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd24',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:18,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Taylor Owsen',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Taylor Owsen',
          link: { label: 'Taylor Owsen', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'owsenT',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '13 (15%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '20/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '3/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '7/10 (70%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View18',
          link: { label: 'View', labelledBy:'studentNamedata_171 View18', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd23',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:19,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'William Thomson',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'William Thomson',
          link: { label: 'William Thomson', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'WilliamThomson',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '48 (55%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '24/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '5/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '6/10 (60%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View19',
          link: { label: 'View', labelledBy:'studentNamedata_181 View19', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd22',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:20,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel:'Zachary Obrien',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Zachary Obrien',
          link: { label: 'Zachary Obrien', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'obrien',
        }
      }],
    },
     {
      headerId: 'totalScore',
      headerName: 'Total score',
      items: [{
        type: 'label',
        values: {
          text: '15 (16%)'
        }
      }],
    }, {
      headerId: 'activities',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '24/30 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        values: {
          text: '2/5 (100%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          text: '8/10 (80%)'
        }
      }],
    },
    {
      headerId: 'activities',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45 (75%)'
        }
      }],
    },
    {
      headerId: 'feedBack',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View20',
          link: { label: 'View', labelledBy:'studentNamedata_191 View20', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd21',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  }
]

export const withoutSubHeaders = [
  {
    field: 'studentName1',
    leftColumnFixed: false, 
    headerName: 'Student Name',
    type : 'text',
    alignment:'left'
  },
  {
    field: 'totalScore1',
    headerName: 'Total Score/90', 
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    icon: 'icon-info-circle',
    type : 'number',
    alignment:'right'
  },
  {
    field: 'activities1',
    headerName: 'Activities - Scores achieved for each activity (first attempt)',
    type : 'number',
    alignment:'center',
    icon: 'icon-info-circle',
    tooltipMessage: 'Trophy achieved by each student for this Challenge',

  },
  {
    field: 'feedBack1',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  },
  {
    field: 'actions1',
    rightColumnFixed: false,
    headerName: 'Actions',
    type : 'dropdown',
    alignment:'center'
  }
]

export const withoutSubHeadersStudentData:any = [
  {
    id:21,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan1',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan1',
          link: { label: 'Aleksander Jordan1', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj121',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack1',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy1',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt11',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View01',
          link: { label: 'View',labelledBy:'studentName1data_01 View01', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye',
          disabled:true,
          disableClass: true
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd401',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option411',
              name: 'option411',
              label: 'option 411',
              url: '/dropdown'
            },
            {
              id: 'option421',
              name: 'option421',
              label: 'option 421',
              url: '/dropdown'
            },
            {
              id: 'option431',
              name: 'option431',
              label: 'option 431',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:22,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan2',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan2',
          link: { label: 'Aleksander Jordan2', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj122',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack2',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy2',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt12',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View120',
          link: { label: 'View2', labelledBy:'studentName1data_11 View120', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd402',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option412',
              name: 'option412',
              label: 'option 412',
              url: '/dropdown'
            },
            {
              id: 'option422',
              name: 'option422',
              label: 'option 422',
              url: '/dropdown'
            },
            {
              id: 'option432',
              name: 'option432',
              label: 'option 432',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:23,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan3',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan3',
          link: { label: 'Aleksander Jordan3', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj123',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack3',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy3',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt13',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View130',
          link: { label: 'View3', labelledBy:'studentName1data_21 View130', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd403',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option413',
              name: 'option413',
              label: 'option 413',
              url: '/dropdown'
            },
            {
              id: 'option423',
              name: 'option423',
              label: 'option 423',
              url: '/dropdown'
            },
            {
              id: 'option433',
              name: 'option433',
              label: 'option 433',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:24,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan4',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan4',
          link: { label: 'Aleksander Jordan4', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj124',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack4',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy4',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt14',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View140',
          link: { label: 'View4', labelledBy:'studentName1data_31 View140', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd404',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option414',
              name: 'option414',
              label: 'option 414',
              url: '/dropdown'
            },
            {
              id: 'option424',
              name: 'option424',
              label: 'option 424',
              url: '/dropdown'
            },
            {
              id: 'option434',
              name: 'option434',
              label: 'option 434',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
    {
    id:25,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan5',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan5',
          link: { label: 'Aleksander Jordan5', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj125',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack5',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy5',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt15',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View150',
          link: { label: 'View5',labelledBy:'studentName1data_41 View150', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd405',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option415',
              name: 'option415',
              label: 'option 415',
              url: '/dropdown'
            },
            {
              id: 'option425',
              name: 'option425',
              label: 'option 425',
              url: '/dropdown'
            },
            {
              id: 'option435',
              name: 'option435',
              label: 'option 435',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:26,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan6',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan6',
          link: { label: 'Aleksander Jordan6', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj126',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack6',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy6',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt16',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View160',
          link: { label: 'View6', labelledBy:'studentName1data_51 View160', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd406',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option416',
              name: 'option416',
              label: 'option 416',
              url: '/dropdown'
            },
            {
              id: 'option426',
              name: 'option426',
              label: 'option 426',
              url: '/dropdown'
            },
            {
              id: 'option436',
              name: 'option436',
              label: 'option 436',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:27,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan7',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan7',
          link: { label: 'Aleksander Jordan7', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj127',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack7',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy7',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt17',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View170',
          link: { label: 'View7',labelledBy:'studentName1data_61 View170', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd407',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option417',
              name: 'option417',
              label: 'option 417',
              url: '/dropdown'
            },
            {
              id: 'option427',
              name: 'option427',
              label: 'option 427',
              url: '/dropdown'
            },
            {
              id: 'option437',
              name: 'option437',
              label: 'option 437',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:28,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan8',
    rowsData:[
      {
      headerId: 'studentName1',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan8',
          link: { label: 'Aleksander Jordan8', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj128',
        }
      }],
    },
     {
      headerId: 'totalScore1',
      headerName: 'Total score',
      items: [{
        type: 'label',
        iconList: [{icon:'icon-backpack',
                iconName:'backpack8',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                iconName:'platinum Trophy8',
                tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        values: {
          text: '62(69%)'
        }
      }],
    }, {
      headerId: 'activities1',
      headerName: 'Activities',
      items: [{
        type: 'label',
        values: {
          text: '20/30(80%)'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt18',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack1',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View180',
          link: { label: 'View8',labelledBy:'studentName1data_71 View180', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions1',
      headerName: 'Actions',
      rightColumnFixed: false,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd408',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option418',
              name: 'option418',
              label: 'option 418',
              url: '/dropdown'
            },
            {
              id: 'option428',
              name: 'option428',
              label: 'option 428',
              url: '/dropdown'
            },
            {
              id: 'option438',
              name: 'option438',
              label: 'option 438',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  }
]

export const newTableHeader = [
  {
    field: 'studentName2',
    leftColumnFixed: false, 
    headerName: 'Student Name',
    type : 'text',
    alignment:'left'
  },
  {
    field: 'totalScore2 | out of 90',
    headerName: 'Total Score', 
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    icon: 'icon-info-circle',
    type : 'number',
    alignment:'laft',
    subTotalscore: 'out of 90'

  },
  {
    field: 'activities2',
    headerName: 'Activities - Scores achieved for each activity (first attempt)',
    type : 'number',
    alignment:'left',
    icon: 'icon-info-circle',
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    subHeader: [{
      headerName: '1',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '2',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '3',
      type:'number',
      alignment:'right'
    },
    {
      headerName: '4',
      type:'number',
      alignment:'right'
    }
  ],
  
  },
  {
    field: 'feedBack2',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  },
  {
    field: 'actions2',
    rightColumnFixed: true,
    headerName: 'Actions',
    type : 'dropdown',
    alignment:'center'
  }
]

export const newTableStudentData:any = [
  {
    id:130,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan',
          link: { label: 'Aleksander Jordan', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj12',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon: '/assets/default/images/trophy/trophy.svg',
                  iconName: 'silver Trophy',
                  tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        trophyNumber: '1',
        values: {
          text: '62 (69%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '20/30'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt1',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy.svg',
                  iconName:'silver Trophy',
                  tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        values: {
          text: '5'
        }
      }]
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          icon:'icon-check-circle',
          iconName:'Assessment completed',
        }
      }],
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 4', 
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45'
        }
      }, {
        type: 'link',
        values: {
          text: 'attempt4',
          link: { label: 'Updated', hyperLink: '/button', target: '_self' }
        }
      }],
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'studentName2data_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd40',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:23,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aniela Keneddy',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aniela Keneddy',
          link: { label: 'Aniela Keneddy', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'KeneddyA',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 4.svg',
        iconName:'gold Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'
      }],
        trophyNumber: '1',
        values: {
          text: '41 (45%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
      subHeaderId: '1',
      items: [{
        type: 'label',
        values: {
          text: '21/30'
        }
      }],
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 4.svg',
        iconName:'gold Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        values: {
          text: '8'
        }
      }],
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          icon:'icon-check-circle',
          iconName:'Assessment completed',
        }
      }],
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 4',
      subHeaderId: '4',
      items: [{
        type: 'label',
        values: {
          text: '30/45'
        }
      }],
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View23',
          link: { label: 'Give', labelledBy:'studentName2data_11 View23', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd39',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:33,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Bardara Freeman',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Bardara Freeman',
          link: { label: 'Bardara Freeman', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'magicbardara',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
 
        values: {
          text: '',
          state: 'Requires grading'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
      subHeaderId: '1',  
  
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 2',
      subHeaderId: '2',
   
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 3',
      subHeaderId: '3',
    
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 4',
      subHeaderId: '4',
    
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View33',
          link: { label: 'View', labelledBy:'studentName2data_21 View33', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd38',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:43,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Brandon Nichols',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Brandon Nichols',
          link: { label: 'Brandon Nichols', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'brandon1000',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 3.svg',
        iconName:'Bronze Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'
      }],
        trophyNumber: '1',
        values: {
          text: '42 (55%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
      subHeaderId: '1',  
      items: [{
        type: 'label',
        values: {
          text: '23/30'
        }
      }]   
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 2',
      subHeaderId: '2',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 3.svg',
        iconName:'Bronze Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'}],
        values: {
          text: '3'
        }
      }]
     
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 3',
      subHeaderId: '3',
      items: [{
        type: 'label',
        values: {
          icon:'icon-check-circle',
          iconName:'Asssessment completed',
        }
      }]     
    },
    {
      headerId: 'activities2',
      headerName: 'Activities 4',
      subHeaderId: '4' 
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View43',
          link: { label: 'View', labelledBy:'studentName2data_31 View43', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd37',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  }
]

export const maxSmallScreenMobileSize = {
  maxSmallScreenMobileSize: 1023
};

export const textAreaTableHeader = [
  {
    field: 'questionNo',
    leftColumnFixed: false, 
    headerName: 'Question no.',
    type : 'text',
    alignment:'right'
  },
  {
    field: 'studentsScore',
    headerName: 'Students Score', 
    type : 'textArea',
    alignment:'right'
  },
  {
    field: 'maxScore',
    rightColumnFixed: false,
    headerName: 'Max Score',
    type : 'text',
    alignment:'right'
  },
  {
    field: 'feedBack3',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  }
]

export const tableStudentDataWithTextArea:any = [
  {
    id:14,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '1'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'textArea',
        values: {
          text: '5',
          maxValue:10,
          textAreaNgModel:''
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:24,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '2'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'textArea',
        values: {
          text: '5',
          maxValue:10,
          textAreaNgModel:''
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:34,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '3'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'numaricInput',
        values: {
          text: '5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:44,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '3'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'numaricInput',
        values: {
          text: '5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:54,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '3'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'formElement',
        values: {
          text: '5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:64,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '3'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'formElement',
        values: {
          text: '5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  },
  {
    id:74,
    checkBoxId:'rowCheckbox',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'label',
        values: {
          text: '3'
        }
      }]
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      items: [{
        type: 'dropdownWithoutIcon',
        values: {
          text: 'dropdown',
          dropdownd:'dropdownd37',
          icon:'icon-chevron-down',
          selectedOptions:{
            id: 'option41',
            name: 'option41',
            label: 'option 41',
            url: '/dropdown'
          },
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    ]
  }
  
]

export const numericTableHeader = [
  {
    field: 'questionNo',
    leftColumnFixed: false, 
    headerName: 'Question no.',
    type : 'text',
    alignment:'right'
  },
  {
    field: 'studentsScore',
    headerName: 'Student\'s Score', 
    type : 'textArea',
    alignment:'right'
  },
  {
    field: 'maxScore',
    rightColumnFixed: false,
    headerName: 'Max Score',
    type : 'text',
    alignment:'right'
  },
  {
    field: 'feedBack3',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  }
]

export const tableStudentDataWithNumericInput:any = [
  {
    id:15,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Question No. 1',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',      
      items: [{
        type: 'link',
        values: {
          text: '1',
          textType: 'number',
          link: { label: '1', hyperLink: '/button', target: '_self' },
          mobileLink:{ label: 'Question 1', hyperLink: '/button', target: '_self' }
        }
      }],      
    },
     {
      headerId: 'studentsScore',
      headerName: 'Student\'s Score',
      hasError: false,
      isEdited:false,
      items: [{
        type: 'formElement',
        formElementId: 'formElementId1',
        inputType: 'text',
        values: {
          text: '4',
          maxScore:'5',
          minVal:0,
          maxVal:10,
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      hasScoreCompare: true,
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'Give', labelledBy:'questionNodata_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    ]
  },
  {
    id:25,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Question No. 2',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      rightColumnFixed: false,
      items: [{
        type: 'link',
        values: {
          text: '2',
          textType: 'number',
          link: { label: '2', hyperLink: '/button', target: '_self' },
          mobileLink:{ label: 'Question 2', hyperLink: '/button', target: '_self' }
        }
      }],
    },
     {
      headerId: 'studentsScore',
      headerName: 'Students Score',
      hasError: true,
      errorId:'inputErrorId',
      errorText: 'Provide Valid Text',
      isEdited:false,
      items: [{
        type: 'formElement',
        formElementId: 'formElementId2',
        inputType: 'text',
        values: {
          text: '5',
          maxScore:'5',
          minVal:0,
          maxVal:10,
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      hasScoreCompare: true,
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'Give', labelledBy:'questionNodata_11 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    ]
  },
  {
    id:35,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Question No. 3',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: '3',
          textType: 'number',
          link: { label: '3', hyperLink: '/button', target: '_self' },
          mobileLink:{ label: 'Question 3', hyperLink: '/button', target: '_self' }
        }
      }],
    },
     {
      headerId: 'studentsScore',
      headerName: 'Student\'s Score',
      hasError: false,
      isEdited:false,
      items: [{
        type: 'formElement',
        formElementId: 'formElementId3',
        inputType: 'text',
        values: {
          text: '5',
          maxScore:'5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      hasScoreCompare: true,
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'Give', labelledBy:'questionNodata_21 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    ]
  },
  {
    id:45,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Question No. 4',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: '4',
          textType: 'number',
          link: { label: '4', hyperLink: '/button', target: '_self' },
          mobileLink:{ label: 'Question 4', hyperLink: '/button', target: '_self' }
        }
      }],
    },
     {
      headerId: 'studentsScore',
      headerName: 'Student\'s Score',
      hasError: false,
      isEdited:false,
      items: [{
        type: 'formElement',
        formElementId: 'formElementId4',
        inputType: 'text',
        values: {
          text: '5',
          maxScore:'5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      hasScoreCompare: true,
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'Give', labelledBy:'questionNodata_31 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    ]
  },
  {
    id:55,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Question No. 5',
    checked: false,
    rowsData:[
      {
      headerId: 'questionNo',
      headerName: 'Question no.',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: '5',
          textType: 'number',
          link: { label: '5', hyperLink: '/button', target: '_self' },
          mobileLink:{ label: 'Question 5', hyperLink: '/button', target: '_self' }
        }
      }],
    },
     {
      headerId: 'studentsScore',
      headerName: 'Student\'s Score',
      isEdited:false,
      items: [{
        type: 'formElement',
        formElementId: 'formElementId5',
        inputType: 'text',
        values: {
          text: '5',
          maxScore:'5',
          minVal:0,
          maxVal:10
        }
      }],
    }, 
    {
      headerId: 'maxScore',
      headerName: 'Max Score',
      hasScoreCompare: true,
      rightColumnFixed: false,
      items: [{
        type: 'label',
        values: {
          text: '5'
        }
      }],
    },
    {
      headerId: 'feedBack3',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'Give', labelledBy:'questionNodata_41 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    ]
  }  
]

export const TableHeaderData = [
  {
      field: 'teacher',
      headerName: 'Teacher',
      hasIcon: false,
      columnAlignment: 'left',
      leftColumnFixed: true,
      hasSorting: true
  },
  {
      field: 'course',
      headerName: 'Course',
      hasIcon: false,
      columnAlignment: 'center',
      hasSorting: false
  },
  {
      field: 'class',
      headerName: 'Class',
      hasIcon: true,
      tooltipMessage:'Classes Info',
      columnAlignment: 'center',
      hasSorting: false
  },
  {
      field: 'average',
      headerName: 'Average',
      hasIcon: true,
      tooltipMessage:'Average Info',
      columnAlignment: 'center',
      hasSorting: false,
      rightColumnFixed: true
  }

]

export const TableRowaData = [
  {
      id: "1",
      teacher: {
          title: 'Marcus Taytum',
          subTitle: 'Tatum88',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      class: {
          title: 'class 1a'
      },
      average: {
        title: '78%',
        rightColumnFixed: true
      }
  },
  {
      id: "2",
      teacher: {
          title: 'Taylor Jhonson',
          subTitle: 'Taytay',
          hasChild: true,
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      class: {
          title: 'class 2b'
      },
      average: {
        title: '78%',
        rightColumnFixed: true
      },
      rowspanLength: 3
  },
  {
    id: "2.1",
    isChild: true,
    course: {
        title: 'Altura Mathematics 2024'
    },
    class: {
        title: 'class 1b'
    },
    average: {
        title: '78%',
        rightColumnFixed: true
    }
},
{
    id: "2.2",
    isChild: true,
    course: {
        title: 'American language hub'
    },
    class: {
        title: 'class 1b',
        hasTag: true,
        tagData: 'Archieved on Jan 1 2021',
        hasIcon: true,
        tooltipMessage: 'Archieved on Jan 1 2021'
    },
    average: {
        title: '78%',
        rightColumnFixed: true
    }
},
  {
      id: "3",
      teacher: {
          title: 'Taylor Silver',
          subTitle: 'Taylor45',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      class: {
          title: 'class 3b'
      },
      average: {
        title: '78%',
        rightColumnFixed: true
      }
  },
  {
    id: "4",
    teacher: {
        title: 'Taylor Silver',
        subTitle: 'Taylor45',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub'
    },
    class: {
        title: 'class 3b'
    },
    average: {
            title: '78%',
        rightColumnFixed: true
    }
},
  {
      id: "5",
      teacher: {
          title: 'Chris Taylor',
          subTitle: 'ChrisT',
          hasChild: true,
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      class: {
          title: 'class 4b'
      },
      average: {
        title: '78%',
        rightColumnFixed: true
      },
      rowspanLength: 2
  },
  {
    id: "5.1",
    isChild: true,
    course: {
        title: 'Altura Mathematics 2024'
    },
    class: {
        title: 'class 1b'
    },
    average: {
        title: '78%',
        rightColumnFixed: true

    }
},
  {
    id: "6",
    teacher: {
        title: 'Marcus Taytum',
        subTitle: 'Tatum88',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub'
    },
    class: {
        title: 'class 1a'
    },
    average: {
        title: '67%',
        rightColumnFixed: true,
    }
},
];

export const ScrollableTableHeaderData = [
  {
      field: 'teacher',
      headerName: 'Teacher',
      hasIcon: false,
      columnAlignment: 'left',
      leftColumnFixed: true,
      hasSorting: true
  },
  {
      field: 'course',
      headerName: 'Course',
      hasIcon: false,
      columnAlignment: 'center',
      hasSorting: false
  },
    {
      field: 'student',
      headerName: 'Studet Name',
      hasIcon: false,
      columnAlignment: 'center',
      hasSorting: false
  },
  {
      field: 'class',
      headerName: 'Class',
      hasIcon: true,
      tooltipMessage:'Classes Info',
      columnAlignment: 'center',
      hasSorting: false
  },
    {  
      field: 'homeWorkAssigned',
      headerName: 'Homework Assigned',
      hasIcon: true,
      tooltipMessage:'Homework Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'homeWorkSubmitted',
      headerName: 'Homework Submitted',
      hasIcon: true,
      tooltipMessage:'homeWorkSubmitted',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'assessmentAssigned',
      headerName: 'Assessment Assigned',
      hasIcon: true,
      tooltipMessage:'Assessment Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'assessmentSubmitted',
      headerName: 'Assessment Submitted',
      hasIcon: true,
      tooltipMessage:'Assessment Submitted',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
      {
      field: 'totalAssigned',
      headerName: 'Total Assigned',
      hasIcon: true,
      tooltipMessage:'Total Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
      {
      field: 'totalSubmitted',
      headerName: 'Total Submitted',
      hasIcon: true,
      tooltipMessage:'Total Submitted',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
  {
      field: 'average',
      headerName: 'Average',
      hasIcon: true,
      tooltipMessage:'Average Info',
      columnAlignment: 'center',
      hasSorting: false,
      rightColumnFixed: true
  }

]

export const ScrollableTableRowaData = [
  {
      id: "1",
      teacher: {
          title: 'Marcus Taytum',
          subTitle: 'Tatum88',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      student: {
          title: 'Billie Eilish',
      },
      class: {
          title: 'class 1a'
      },
      homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 3},
      assessmentAssigned:{title: 4},
      assessmentSubmitted: {title: 5},
      totalAssigned: {title: 7},
      totalSubmitted: {title: 6},
      average: {
        title: '78%',
        rightColumnFixed: true
      }
  },
  {
      id: "2",
      teacher: {
          title: 'Taylor Jhonson',
          subTitle: 'Taytay',
          hasChild: true,
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      student: {
          title: 'Billie',
      },
      class: {
          title: 'class 2b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        rightColumnFixed: true
      },
      rowspanLength: 3
  },
  {
    id: "2.1",
    isChild: true,
    course: {
        title: 'Altura Mathematics 2024'
    },
    student: {
          title: 'Eilish',
      },
    class: {
        title: 'class 1b'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
        title: '78%',
        rightColumnFixed: true
    }
},
{
    id: "2.2",
    isChild: true,
    course: {
        title: 'American language hub'
    },
    student: {
          title: 'Taylor',
      },
    class: {
        title: 'class 1b',
        hasTag: true,
        tagData: 'Archieved on Jan 1 2021',
        hasIcon: true,
        tooltipMessage: 'Archieved on Jan 1 2021'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
        title: '78%',
        rightColumnFixed: true
    }
},
  {
      id: "3",
      teacher: {
          title: 'Taylor Silver',
          subTitle: 'Taylor45',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      student: {
          title: 'Alex',
      },
      class: {
          title: 'class 3b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        rightColumnFixed: true
      }
  },
  {
    id: "4",
    teacher: {
        title: 'Taylor Silver',
        subTitle: 'Taylor45',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub'
    },
    student: {
          title: 'silver',
      },
    class: {
        title: 'class 3b'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
            title: '78%',
        rightColumnFixed: true
    }
},
  {
      id: "5",
      teacher: {
          title: 'Chris Taylor',
          subTitle: 'ChrisT',
          hasChild: true,
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub'
      },
      student: {
          title: 'Robert',
      },
      class: {
          title: 'class 4b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        rightColumnFixed: true
      },
      rowspanLength: 2
  },
  {
    id: "5.1",
    isChild: true,
    course: {
        title: 'Altura Mathematics 2024'
    },
    student: {
          title: 'Chris',
      },
    class: {
        title: 'class 1b'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
        title: '78%',
        rightColumnFixed: true

    }
},
  {
    id: "6",
    teacher: {
        title: 'Marcus Taytum',
        subTitle: 'Tatum88',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub'
    },
    student: {
          title: 'Freeman',
      },
    class: {
        title: 'class 1a'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
        title: '67%',
        rightColumnFixed: true,
    }
},
];

export const ScrollableCustomTableHeaderData = [
  {
      field: 'teacher',
      headerName: 'Teacher',
      hasIcon: false,
      columnAlignment: 'left',
      leftColumnFixed: true,
      hasSorting: true
  },
  {
      field: 'course',
      headerName: 'Course',
      hasIcon: false,
      columnAlignment: 'center',
      hasSorting: false
  },
    {
      field: 'student',
      headerName: 'Studet Name',
      hasIcon: false,
      columnAlignment: 'center',
      hasSorting: false
  },
  {
      field: 'class',
      headerName: 'Class',
      hasIcon: true,
      tooltipMessage:'Classes Info',
      columnAlignment: 'center',
      hasSorting: false
  },
    {  
      field: 'homeWorkAssigned',
      headerName: 'Homework Assigned',
      hasIcon: true,
      tooltipMessage:'Homework Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'homeWorkSubmitted',
      headerName: 'Homework Submitted',
      hasIcon: true,
      tooltipMessage:'homeWorkSubmitted',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'assessmentAssigned',
      headerName: 'Assessment Assigned',
      hasIcon: true,
      tooltipMessage:'Assessment Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
    {
      field: 'assessmentSubmitted',
      headerName: 'Assessment Submitted',
      hasIcon: true,
      tooltipMessage:'Assessment Submitted',
      columnAlignment: 'center',
      type:'customized',
      hasSorting: false
  },
      {
      field: 'totalAssigned',
      headerName: 'Total Assigned',
      hasIcon: true,
      tooltipMessage:'Total Assigned',
      columnAlignment: 'center',
      type:'number',
      hasSorting: false
  },
      {
      field: 'totalSubmitted',
      headerName: 'Total Submitted',
      hasIcon: true,
      tooltipMessage:'Total Submitted',
      columnAlignment: 'right',
      type:'number',
      hasSorting: false
  },
  {
      field: 'average',
      headerName: 'Average',
      hasIcon: true,
      tooltipMessage:'Average Info',
      columnAlignment: 'center',
      hasSorting: false,
      type:'customized',
      rightColumnFixed: true
  }
]

export const ScrollableCustomTableRowaData = [
  {
      id: "1",
      teacher: {
          title: 'Marcus Taytum',
          subTitle: 'Tatum88',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub',
      },
      student: {
          title: 'Billie Eilish',
      },
      class: {
          title: 'class 1a'
      },
      homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 3},
      assessmentAssigned:{title: 4},
      assessmentSubmitted: {title: 5},
      totalAssigned: {title: 7},
      totalSubmitted: {title: 6},
      average: {
        title: '78%',
        icon: 'icon-download',
        rightColumnFixed: true
      }
  },
  {
      id: "2",
      teacher: {
          title: 'Taylor Jhonson',
          subTitle: 'Taytay',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub',
      },
      student: {
          title: 'Billie',
      },
      class: {
          title: 'class 2b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        icon: 'icon-download',
        rightColumnFixed: true
      },
      rowspanLength: 3
  },
  {
      id: "3",
      teacher: {
          title: 'Taylor Silver',
          subTitle: 'Taylor45',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub',
      },
      student: {
          title: 'Alex',
      },
      class: {
          title: 'class 3b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        icon: 'icon-download',
        rightColumnFixed: true
      }
  },
  {
    id: "4",
    teacher: {
        title: 'Taylor Silver',
        subTitle: 'Taylor45',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub',
    },
    student: {
          title: 'silver',
      },
    class: {
        title: 'class 3b'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
            title: '78%',
            icon: 'icon-download',
        rightColumnFixed: true
    }
},
  {
      id: "5",
      teacher: {
          title: 'Chris Taylor',
          subTitle: 'ChrisT',
          leftColumnFixed: true,
      },
      course: {
          title: 'American language hub',
      },
      student: {
          title: 'Robert',
      },
      class: {
          title: 'class 4b'
      },
              homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
      average: {
        title: '78%',
        icon: 'icon-download',
        rightColumnFixed: true
      },
      rowspanLength: 2
  },
  {
    id: "6",
    teacher: {
        title: 'Marcus Taytum',
        subTitle: 'Tatum88',
        leftColumnFixed: true,
    },
    course: {
        title: 'American language hub',
    },
    student: {
          title: 'Freeman',
      },
    class: {
        title: 'class 1a'
    },
            homeWorkAssigned :{title: 2},
      homeWorkSubmitted: {title: 2},
      assessmentAssigned:{title: 2},
      assessmentSubmitted: {title: 2},
      totalAssigned: {title: 2},
      totalSubmitted: {title: 2},
    average: {
        title: '67%',
        icon: 'icon-download',
        rightColumnFixed: true,
    }
},
];

export const tableDataWithDifferentModes = [
  {
    sNo:1,
    id:'leon',
    studentName: 'Leon',
    userName: 'Noah',
    checked: true
  },
  {
    sNo:2,
    id:'oliver',
    studentName:'Oliver',
    userName: 'Fonn',
  },
  {
    sNo:3,
    id:'george',
    studentName:{
      value: '45',
      text: 'value'
    },
    userName: 'John',
    active: true
    
  },
  {
    sNo:4,
    id:'jhon',
    studentName:'Jhon',
    userName: 'Leon',  
    inActive: true 
  },
  {
    sNo:5,
    id:'oliver',
    studentName:'Oliver',
    userName: 'Fonn',
  },
  {
    sNo:6,
    id:'george',
    studentName:'George',
    userName: 'John',
    disabled: true 
  },
  {
    sNo:7,
    id:'jhon',
    studentName:{
      value: '45',
      text: 'value'
    },
    userName: 'Leon',    
  }
]

export const ptTableCustomHeader = [
  {
    field: 'studentName2',
    leftColumnFixed: false, 
    headerName: 'Student Name',
    type : 'text',
    alignment:'left'
  },
  {
    field: 'totalScore2 | out of 90',
    headerName: 'Total Score', 
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
    icon: 'icon-info-circle',
    type : 'number',
    alignment:'laft',
    subTotalscore: 'out of 90'

  },
  {
    field: 'activities2',
    headerName: 'Activities - Scores achieved for each activity (first attempt)',
    type : 'customized',
    alignment:'left',
    icon: 'icon-info-circle',
    tooltipMessage: 'Trophy achieved by each student for this Challenge',
  },
  {
    field: 'feedBack2',
    headerName: 'Feedback', 
    type : 'link',
    alignment:'center'
  },
  {
    field: 'actions2',
    rightColumnFixed: true,
    headerName: 'Actions',
    type : 'dropdown',
    alignment:'center'
  }
]

export const ptTableCustomStudentData:any = [
  {
    id:130,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aleksander Jordan',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aleksander Jordan',
          link: { label: 'Aleksander Jordan', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'alexjj12',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon: '/assets/default/images/trophy/trophy.svg',
                  iconName: 'silver Trophy',
                  tooltipMessage: 'Trophy achieved by each student for this Challenge'
              }],
        trophyNumber: '1',
        values: {
          text: '62 (69%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
      items: [{
        type: 'customized',
        values: {
          headerText: 'Header Text',
          text: 'Subheader Text'
        }
      }],
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View13',
          link: { label: 'View', labelledBy:'studentName2data_01 View13', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd40',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:23,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Aniela Keneddy',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Aniela Keneddy',
          link: { label: 'Aniela Keneddy', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'KeneddyA',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 4.svg',
        iconName:'gold Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'
      }],
        trophyNumber: '1',
        values: {
          text: '41 (45%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',
       items: [{
        type: 'customized',
        values: {
          headerText: 'Header Text',
          text: 'Subheader Text'
        }
      }],
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View23',
          link: { label: 'Give', labelledBy:'studentName2data_11 View23', hyperLink: '/button', target: '_self' },
          icon: 'icon-plus-circle'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd39',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:33,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Bardara Freeman',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Bardara Freeman',
          link: { label: 'Bardara Freeman', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'magicbardara',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
 
        values: {
          text: '',
          state: 'Requires grading'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1', 
       items: [{
        type: 'customized',
        values: {
          headerText: 'Header Text',
          text: 'Subheader Text'
        }
      }],  
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View33',
          link: { label: 'View', labelledBy:'studentName2data_21 View33', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd38',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  },
  {
    id:43,
    checkBoxId:'rowCheckbox',
    checkBoxAriaLabel: 'Brandon Nichols',
    checked: false,
    rowsData:[
      {
      headerId: 'studentName2',
      headerName: 'Student name',
      leftColumnFixed: false, 
      items: [{
        type: 'link',
        values: {
          text: 'Brandon Nichols',
          link: { label: 'Brandon Nichols', hyperLink: '/button', target: '_self' }
        }
      }, {
        type: 'label',
        values: {
          text: 'brandon1000',
        }
      }],
    },
     {
      headerId: 'totalScore2 | out of 90',
      headerName: 'Total score | out of 90',
      items: [{
        type: 'label',
        images: [{icon:'/assets/default/images/trophy/trophy 3.svg',
        iconName:'Bronze Trophy',
        tooltipMessage: 'Trophy achieved by each student for this Challenge'
      }],
        trophyNumber: '1',
        values: {
          text: '42 (55%)'
        }
      }],
    }, {
      headerId: 'activities2',
      headerName: 'Activities 1',  
       items: [{
        type: 'customized',
        values: {
          headerText: 'Header Text',
          text: 'Subheader Text'
        }
      }],  
    },
    {
      headerId: 'feedBack2',
      headerName: 'FeedBack',
      items: [{
        type: 'link',
        values: {
          text: 'View43',
          link: { label: 'View', labelledBy:'studentName2data_31 View43', hyperLink: '/button', target: '_self' },
          icon: 'icon-eye'
        }
      }],
    },
    {
      headerId: 'actions2',
      headerName: 'Actions',
      rightColumnFixed: true,
      items: [{
        type: 'dropdown',
        values: {
          text: 'dropdown',
          ariaLabel: 'actions',
          dropdownd:'dropdownd37',
          icon: 'icon-dots-vertical',
          options: [
            {
              id: 'option41',
              name: 'option41',
              label: 'option 41',
              url: '/dropdown'
            },
            {
              id: 'option42',
              name: 'option42',
              label: 'option 42',
              url: '/dropdown'
            },
            {
              id: 'option43',
              name: 'option43',
              label: 'option 43',
              url: '/dropdown'
            }
          ]
        }
      }],
    }
    ]
  }
]
